// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import { mergeClasses } from '@fluentui/react-components';
import React from 'react';
import { useAppStyles } from '../../styles';
import { TrackContext } from '../common';
import IdentityGroup from './identity-group';
import LogoHomeLink from './logo-home-link';
import NavigationGroup from './navigation-group';
import SkipToContentLink from './skip-to-content-link';

// Top header control.
export default () => {
    const appStyles = useAppStyles();
    return (
        <TrackContext.Provider value={{ container: 'header' }}>
            <SkipToContentLink />
            <header className={mergeClasses(appStyles.header, 'content-width')}>
                <span className={appStyles.desktopOnly}>
                    <LogoHomeLink />
                </span>
                <NavigationGroup />
                <div className={appStyles.flexGrow1}>
                    <div className={mergeClasses(appStyles.desktopHidden, appStyles.alignCenter)}>
                        <LogoHomeLink />
                    </div>
                </div>
                <IdentityGroup />
            </header>
        </TrackContext.Provider>
    );
};
